/**
 * Stub vacío para @nestjs/swagger en el bundle del frontend.
 *
 * Los DTOs en libs/shared usan decoradores de Swagger (@ApiProperty, etc.)
 * que solo aplican al backend NestJS para generar la documentación OpenAPI.
 * En el browser son inertes — pero esbuild bundlea todo el código de
 * @nestjs/swagger, que a su vez jala @nestjs/core, stream, etc. (rompe en
 * runtime porque son APIs de Node).
 *
 * Este stub se aplica vía `paths` en tsconfig.app.json del frontend, así
 * cualquier `import from '@nestjs/swagger'` en código del shared se redirige
 * acá. Resultado: los decoradores existen como funciones noop en el browser.
 *
 * NO afecta el backend — el backend usa el path real de node_modules.
 */
/* eslint-disable no-unused-vars */
// Tipos: deliberadamente sueltos — este archivo es un stub que NO se ejecuta
// (los decoradores @ApiProperty etc. no hacen nada en el browser).

type AnyVal = any;
type AnyFn = (...args: AnyVal[]) => any;

const noopDecorator = (..._args: AnyVal[]): AnyFn =>
    ((_target: AnyVal, _propertyKey?: AnyVal, _descriptor?: AnyVal) => {
        return undefined;
    }) as AnyFn;

const noopClassDecorator = (..._args: AnyVal[]): AnyFn =>
    ((_target: AnyVal) => _target) as AnyFn;

// Property decorators (más usados en DTOs)
export const ApiProperty = noopDecorator;
export const ApiPropertyOptional = noopDecorator;
export const ApiHideProperty = noopDecorator;
export const ApiResponseProperty = noopDecorator;

// Class decorators
export const ApiTags = noopClassDecorator;
export const ApiExtraModels = noopClassDecorator;
export const ApiSchema = noopClassDecorator;

// Method decorators
export const ApiOperation = noopDecorator;
export const ApiResponse = noopDecorator;
export const ApiOkResponse = noopDecorator;
export const ApiCreatedResponse = noopDecorator;
export const ApiBadRequestResponse = noopDecorator;
export const ApiUnauthorizedResponse = noopDecorator;
export const ApiForbiddenResponse = noopDecorator;
export const ApiNotFoundResponse = noopDecorator;
export const ApiConflictResponse = noopDecorator;
export const ApiInternalServerErrorResponse = noopDecorator;
export const ApiBody = noopDecorator;
export const ApiParam = noopDecorator;
export const ApiQuery = noopDecorator;
export const ApiHeader = noopDecorator;
export const ApiHeaders = noopDecorator;
export const ApiBearerAuth = noopDecorator;
export const ApiBasicAuth = noopDecorator;
export const ApiOAuth2 = noopDecorator;
export const ApiSecurity = noopDecorator;
export const ApiConsumes = noopDecorator;
export const ApiProduces = noopDecorator;
export const ApiExcludeEndpoint = noopDecorator;
export const ApiExcludeController = noopClassDecorator;

// Mapped types helpers (usados en backend para generar DTOs)
export const PartialType = (klass: AnyVal): AnyVal => klass;
export const PickType = (klass: AnyVal, _keys: AnyVal): AnyVal => klass;
export const OmitType = (klass: AnyVal, _keys: AnyVal): AnyVal => klass;
export const IntersectionType = (a: AnyVal, _b: AnyVal): AnyVal => a;

// Document builder y SwaggerModule (no usados en frontend pero por si acaso)
export class DocumentBuilder {
    setTitle(_t: string) {
        return this;
    }
    setDescription(_d: string) {
        return this;
    }
    setVersion(_v: string) {
        return this;
    }
    addTag(_t: string) {
        return this;
    }
    addBearerAuth() {
        return this;
    }
    build() {
        return {};
    }
}
export const SwaggerModule = {
    createDocument: (..._args: AnyVal[]) => ({}),
    setup: (..._args: AnyVal[]) => undefined,
};

// Default export para compat
export default {};
